import { render, staticRenderFns } from "./BanksRedirect.vue?vue&type=template&id=27319b35&scoped=true&"
import script from "./BanksRedirect.vue?vue&type=script&lang=js&"
export * from "./BanksRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27319b35",
  null
  
)

export default component.exports